import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ADDRESS, PHONE, PHONE_HREF, SERVICES, SERVICE_ROUTES } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-charcoal text-warm/70">
    <div className="container-cando grid gap-14 py-20 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <Link to="/" data-testid="footer-logo" className="leading-none">
          <span className="block font-heading text-2xl font-extrabold tracking-[0.08em] text-warm">CANDO</span>
          <span className="mt-1 block font-heading text-[10px] font-bold tracking-[0.42em] text-bronze">
            CONSTRUCTION
          </span>
        </Link>
        <p className="mt-6 max-w-xs text-[15px] leading-relaxed">
          Framing, renovations and additions for Edmonton homeowners.
        </p>
      </div>

      <div>
        <p className="font-heading text-[13px] font-bold uppercase tracking-[0.22em] text-warm">Services</p>
        <ul className="mt-5 space-y-2.5 text-[15px]">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={SERVICE_ROUTES[s.slug]} data-testid={`footer-service-${s.slug}`} className="transition-colors hover:text-bronze">
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-heading text-[13px] font-bold uppercase tracking-[0.22em] text-warm">Company</p>
        <ul className="mt-5 space-y-2.5 text-[15px]">
          <li><Link data-testid="footer-link-about" to="/#about" className="transition-colors hover:text-bronze">About</Link></li>
          <li><Link data-testid="footer-link-projects" to="/#projects" className="transition-colors hover:text-bronze">Projects</Link></li>
          <li><Link data-testid="footer-link-process" to="/#process" className="transition-colors hover:text-bronze">Process</Link></li>
          <li><Link data-testid="footer-link-faq" to="/#faq" className="transition-colors hover:text-bronze">FAQ</Link></li>
          <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors hover:text-bronze">Contact</Link></li>
        </ul>
      </div>

      <div>
        <p className="font-heading text-[13px] font-bold uppercase tracking-[0.22em] text-warm">Contact</p>
        <address className="mt-5 space-y-3 text-[15px] not-italic leading-relaxed" data-testid="footer-contact">
          <p>{ADDRESS}</p>
          <a href={PHONE_HREF} data-testid="footer-phone" className="group inline-flex items-center gap-1.5 text-warm transition-colors hover:text-bronze">
            {PHONE}
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </address>
        <Link to="/contact" data-testid="footer-quote-button" className="btn btn-bronze mt-7 !px-6 !py-3">
          Get a Project Estimate
        </Link>
      </div>
    </div>

    <div className="border-t border-warm/10">
      <div className="container-cando flex flex-col items-start justify-between gap-2 py-6 text-[13px] text-warm/40 sm:flex-row sm:items-center">
        <p data-testid="footer-copyright">© 2026 Cando Construction Services Ltd.</p>
        <p>Edmonton, Alberta</p>
      </div>
    </div>
  </footer>
);
